module.exports = __webpack_public_path__ + "img/program.5acfda10.png";